import { useEffect, useState } from "react";
import { Button, openModal } from "risa-oasis-ui_v2";
import FormConfigModal from "../../../../../components/modals/formConfigModal/formConfigModal";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      openModal("form-config-modal");
    }
  }, [isOpen]);

  return (
    <div className="flex w-full items-center justify-between">
      <div className="font-bold">Form Config</div>
      <div>
        <Button
          disabled={false}
          onClick={() => setIsOpen(true)}
          buttonType="primary"
          size="small"
        >
          Create Form
        </Button>
      </div>
      {isOpen && <FormConfigModal onClose={() => setIsOpen(false)} />}
    </div>
  );
};

export default Header;
